import React, { useState, useEffect } from "react";
import HubspotForm from "react-hubspot-form";
import $ from "jquery"; // hbspt.forms.create requires jQuery



const HSInlineForm = ({formdata = "", siteFullName = "", hasRelatedConversion = false}) => {

    const formArray = formdata ? formdata.split(",").map(item => item.trim()) : [];
    const [isClient, setIsClient] = useState(false); // window is loaded
    const [formIndex, setFormIndex] = useState(0); // current dispaly form

    useEffect(() => {
        setIsClient(true);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }, []);

    const updateStyle = () => {
        if (formArray.length === 1) {
            return;
        }
        // only show progress bar when more than one form
        const progressBar = document.querySelector(".progress-bar");
        const actives = document.querySelectorAll(".active");
        if (actives.length > 1) {
            // make sure the line of the progress bar always extend to the right position where the progress circles are, no matter how many forms are in there
            progressBar.style.width =
                `calc( ${((actives.length - 1) / (formArray.length - 1)) * 100}% - 80px * ${((actives.length - 1) / (formArray.length - 1))})`
        }
    };

    const onFormSubmitted = () => {
        if (formArray.length > 0) {
            if (formIndex < (formArray.length - 1)) setFormIndex(prev => prev + 1);
            else {
                const HSInlineForm = document.querySelector("#HSInlineForm");
                const formHeader = document.querySelector(".form-header");
                const formFooter = document.querySelector(".form-footer");
                const submittedMessage = document.querySelector(".submitted-message");

                HSInlineForm.classList.add("formsAreFilled");
                if (formHeader) formHeader.classList.add("display-none"); // There's no form header when it's a single form. But it's multi-forms, we want to hide the form header once all the forms are filled.
                if (hasRelatedConversion) formFooter.classList.add("display-none"); // After the forms are filled, hiding form footer would depend on whether we have any related contents.
                if (submittedMessage) {
                    submittedMessage.querySelectorAll("p").forEach(el => el.textContent.trim() === "" && el.parentNode.removeChild(el)); // remove empty p
                    submittedMessage.querySelectorAll("a").forEach(el => {
                        const downloadRegex = /download/i;
                        if(downloadRegex.test(el.innerText)) el.classList.add("btn", "brandedButton", "inverted");
                    });
                }
            }
        }
    };

    // have to have this function defined
    const onSubmit = () => {
    };

    const rederForm = () => {
        return (<HubspotForm
            portalId="547446"
            key={`form-${formIndex}`}
            formId={formArray[formIndex]}
            onSubmit={onSubmit}
            onFormSubmitted={onFormSubmitted}
            onReady={updateStyle}
            loading={<div>Loading form...</div>}
        />);
    };

    return (
        <>
            {(formArray.length > 1) &&
                <div className="form-header">
                    <div className="progress-wrapper">
                        <div className="progress-bar"></div>
                        {formArray.map((form, index) => {
                            let key =  `step-` + index;
                            let stepClass = `step ${key}` ;
                            if (index <= formIndex) stepClass += ` active`;
                            return (
                                <div className={stepClass} key={key}>
                                    <div className="progress-circle"></div>
                                    <span className="progress-text">Step {index + 1} of {formArray.length} </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            }
            <div className="in-line-form">
                {isClient && rederForm()}
            </div>
            <div className="form-footer">
                <p><small>The information you provide will be shared with the sponsors of this content. <em>{siteFullName}</em> or its sponsors may contact you to offer you content or products based on your interest in this topic. You may unsubscribe from these communications at any time. For information on how to unsubscribe, our privacy practices, and commitment to protecting your privacy, check out our <a href="/privacy-policy">Privacy Policy</a>.</small></p>
            </div>

        </>
    );
};

export default HSInlineForm;
